import settings from "../settings";
import isEmpty from "lodash/isEmpty";
import { TYPE_GLOBAL_SEARCH } from "../Actions/ActionClanRating";

export const lastSeason = settings.ladder.seasons[settings.ladder.lastSeasonId] || {};

export const getMajorLeagueNumber = season => {
  return (season && season.leagues && season.leagues[0]) ? 0 : 1;
};

export const getSeasonInfo = seasonNumber => {
  return settings.ladder.seasons[seasonNumber] || {};
};

export const getMajorLeagueNumberBySeasonNumber = seasonNumber => {
  const season = getSeasonInfo(seasonNumber);

  return !isEmpty(season) ? getMajorLeagueNumber(season) : 1;
};

export const getSeasonLeagues = seasonNumber => {
  return settings.ladder.seasons[seasonNumber] ? settings.ladder.seasons[seasonNumber].leagues : [];
};

export const isQualifiedByBestSeasonTeam = (teams, season, realm) => {
  const seasonTeamsWithBestRating = teams.filter(team => team.season_number === parseInt(season, 10) && team.is_best_season_rating && (realm === TYPE_GLOBAL_SEARCH || team.realm === realm));
  return !isEmpty(seasonTeamsWithBestRating);
};

export const getSeasonTeams = (teams, season) => {
  return teams.filter(team => team.season_number === season);
};